import { useState, useRef, useCallback } from 'react';
import { useOnClickOutside } from '@services/hooks.service';
import TranslationsProvider, { useTranslation } from '@utils/i18n/i18n';
import { createRoot } from 'react-dom/client';

import translator from '@App/app.translator';

import './language-switch.styl';

function LanguageSwitch() {
  const {
    t, lang, languages, setLang, 
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const switchRef = useRef();

  useOnClickOutside(switchRef, useCallback(() => setIsOpen(false), []));

  return (
    <div 
      className={`language-switch${isOpen ? ' language-switch--is-open' : ''}`}
      onClick={() => setIsOpen(!isOpen)}
      ref={switchRef}
    >
      <button 
        className={`language-switch__button${isOpen ? ' language-switch__button--active' : ''}`}
        type="button"
        title={t('map-control_language-select_tooltip')}
      >
        {lang}
      </button>
      {isOpen && languages.filter(l => l !== lang).map(l => (
        <button 
          className="language-switch__button" 
          type="button"
          onClick={() => setLang(l)}
          key={l}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

class LanguageSwitchControl {
  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
    this._root = createRoot(this._container);
    this._root.render(
      <TranslationsProvider translator={translator}>
        <LanguageSwitch />
      </TranslationsProvider>,
    );
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default LanguageSwitchControl;